const idInWords = (id) =>
    String(id ?? '')
        .split(/[_\-\s]+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

// The step's `title` attribute; a step without one shows its id in words
// (`bobtail_authorization` -> "Bobtail Authorization").
export function sectionTitle(step) {
    return step?.title || idInWords(step?.id);
}
